import React from 'react'
import { Container, Grid2, Typography, Box } from '@mui/material';

const Organizadores = () => {
    return (
        <Container maxWidth={false} id='organizadores-container'>
            <Box sx={{ mt: 3, p: 5, borderRadius: '3em', textAlign: 'center' }}>
                <Typography variant='h4' fontWeight={900}>ORGANIZADORES</Typography>
            </Box>

            <Grid2 container spacing={3} sx={{ mt: 3, p: 5, fontStyle: 'italic' }}>
                <Grid2 item size={{ xs: 12, md: 6, lg: 6 }} alignContent='center' style={{ textAlign: 'center' }}>
                    <img
                        loading='lazy'
                        src='https://escuela-bancaria.s3.us-east-2.amazonaws.com/c0a6bc46-1b30-41d8-b874-ab6fa8a5d256.png'
                        style={{ width: '50%', objectFit: 'contain' }}
                        alt='FELABAN Logo'
                    />
                </Grid2>
                <Grid2 item size={{ xs: 12, md: 6, lg: 6 }} alignContent='center'>
                    <Typography textAlign='justify' fontSize='1em'>
                        <strong> La Federación Latinoamericana de Bancos, FELABAN</strong>, es una institución sin fines de lucro, constituida en 1965 en la ciudad de Mar del Plata, República Argentina. Agrupa, a través de sus respectivas asociaciones en 19 países del continente, a más de 623 bancos y entidades financieras de América Latina.
                    </Typography>
                    <Typography fontWeight='bold' mt={2}>Objetivos:</Typography>
                    <ul>
                        <li>
                            Contribuir por conducto de sus servicios técnicos a la coordinación de criterios y a la unificación de usos y prácticas bancarias y financieras en general en Latinoamérica.
                        </li>
                        <li>
                            Cooperar dentro de las actividades que le son propias, al más eficaz desarrollo económico de los países latinoamericanos y al de los movimientos de integración económica en que participen.
                        </li>
                        <li>
                            Propender por todos los medios a su alcance el desarrollo y bienestar de los países en que radiquen sus miembros.
                        </li>
                        <li>
                            Propender por una mayor profundización financiera y mayor acceso de los grupos poblacionales de menor ingreso a los servicios financieros como forma de contribuir a la disminución de la pobreza en los países latinoamericanos.
                        </li>
                    </ul>
                </Grid2>
            </Grid2>

            <Grid2 container spacing={3} sx={{ mt: 3, p: 5, fontStyle: 'italic' }}>
                <Grid2 item size={{ xs: 12, md: 6, lg: 6 }} alignContent='center' style={{ textAlign: 'center' }}>
                    <img
                        loading='lazy'
                        src='https://escuela-bancaria.s3.us-east-2.amazonaws.com/logo+ABG+azul.png'
                        style={{ width: '50%', objectFit: 'contain' }}
                        alt='ABG Logo'
                    />
                </Grid2>
                <Grid2 item size={{ xs: 12, md: 6, lg: 6 }} alignContent='center'>
                    <Typography textAlign='justify' fontSize='1em'>
                        <strong>La Asociación Bancaria de Guatemala –ABG</strong>                         Es la Asociación civil y de carácter gremial, integrada por todas las entidades Bancarias y Sociedades Financieras Privadas autorizadas para operar en Guatemala. Fue constituida el 8 de septiembre de 1961 y es Miembro Fundador de la Federación Latinoamericana de Bancos –FELABAN-, en la que tiene representación a través de sus Comités Técnicos.

                    </Typography>
                    <Typography fontWeight='bold' mt={2}>Principales Objetivos:</Typography>
                    <ul>
                        <li>
                            Defender y velar por los intereses de sus miembros oportuna y diligentemente.
                        </li>
                        <li>
                            Emitir opinión sobre los proyectos de ley y reglamentos, que en materia financiera o relacionados con el sistema bancario surgieren, así como gestionar ante las autoridades y organismos respectivos la emisión de aquellas disposiciones que considere convenientes, o la modificación de las existentes.
                        </li>
                        <li>
                            Propugnar por la modernización de las prácticas bancarias y de los instrumentos financieros, para propiciar el ahorro y estimular la inversión en proyectos que beneficien el desarrollo económico nacional.
                        </li>
                        <li>
                            Velar porque se mantengan las mejores condiciones financieras y de confianza en el País.
                        </li>
                        <li>
                            Velar porque la estructura institucional del sistema bancario, permita el mejor desenvolvimiento de sus actividades en general, en consonancia con las prácticas modernas, tanto a nivel nacional como internacional.
                        </li>
                        <li>
                            Coadyuvar para que el sistema financiero nacional mantenga una corriente fluida de recursos que garanticen el normal desarrollo de las actividades productivas del País.
                        </li>
                        <li>
                            Prestar apoyo a sus miembros asociados a través del servicio de interconexión electrónica bancaria.
                        </li>
                    </ul>
                </Grid2>
            </Grid2>


        </Container>)
}

export default Organizadores